import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { personalChatNameError } from "../personalChatName";
import { userFacingError } from "../userFacingError";
import { mutator } from "./mutator";

export const renamePersonalChat = mutator({
  schema: z.object({ id: z.string(), name: z.string() }),
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  description: "Triggered when a user renames a personal chat.",
  interactionType: "update",
  fn: async ({ tx, ctx, args }) => {
    const chat = await tx.run(
      zql.personalChats
        .where("deletedAt", "IS", null)
        .where("id", args.id)
        .where("userId", ctx.userId)
        .where("tenantId", ctx.tenantId)
        .one()
    );
    if (!chat) throw userFacingError("Personal chat not found");

    const name = args.name.trim();
    const error = personalChatNameError(name);
    if (error) throw userFacingError(error);

    await tx.mutate.personalChats.update({
      id: chat.id,
      name,
      userChangedNameAt: Date.now(),
    });
  },
});
